export const BaseUrl = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    localBaseUrl: process.env.REACT_APP_TEST_BASE_URL,
}